export default __webpack_public_path__ + "static/media/35k.afdc2e82.md";